// extracted by mini-css-extract-plugin
export var childrenContainer = "_ar-0";
export var virtualScrollArea = "_ar-1";